import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useEntityCrud } from '../../../hooks/useEntityCrud'
import { toast } from 'react-toastify'

const Create = () => {

    const { addData } = useEntityCrud('Support/setTopic')
    const navigate = useNavigate()

    const [title,setTitle] = useState('')
    const [criticism,setCriticism] = useState('')

    const save = () => {
        const postedData = {
            title,
            criticism: criticism == 1
        }
        addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('موضوع جدید با موفقیت ایجاد شد')
                navigate('/tickets')
            }else
                data.errors.map(error => toast.error(error.message))
        })
    }

    return (
        <div className="card mt-4">
            <div className="card-header px-4">
                <div className="card-title">افزودن موضوع جدید</div>
            </div>
            <div className="card-body p-4">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>عنوان</label>
                            <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>نوع موضوع</label>
                            <select className="form-control" onChange={e => setCriticism(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                <option value="1">شکایت</option>
                                <option value="2">پشتیبانی</option>
                            </select>
                        </div>
                    </div>
                </div>
                <button className="btn btn-success" onClick={save} disabled={!criticism}>ذخیره اطلاعات</button>
            </div>
        </div>
    )
}

export default Create